export default "__VITE_ASSET__874fede6__"